import styled from 'styled-components'
import { t, jt } from 'ttag'
import { useDispatch } from 'react-redux'

import { features } from '@h2/components/media'
import { WHITE, BODY, PB90T, SG } from '@h2/components/colors'
import { Flex } from '@h2/components/layout/flex'
import { Box } from '@h2/components/layout/box'
import { Heading as HeadingComponent } from '@h2/components/typography/heading'
import { PromoButton } from '@h2/components/buttons/promo'
import { Panel as PanelComponent } from '@h2/common/components/panel'
import { openSigninDialog } from '@main/actions/signinOrRegisterDialog'

const startedToday = <span key="started">{t`started today`}</span>
const free = <span key="free">{t`free`}</span>
const Panel = styled(PanelComponent)`
  @media (${features.minWidth.desktop}) {
    display: none;
  }
`
const Heading = styled(HeadingComponent)`
  font-size: 36px;
  line-height: 38px;
  text-align: center;
  margin: 0 0 10px 0;
  text-transform: uppercase;
  span {
    color: ${SG};
  }
`
const HeadingTop = styled(Heading)`
  font-size: 38px;
  letter-spacing: 2px;
  margin: 0;
`
const CallToAction = () => {
  const dispatch = useDispatch()

  return (
    <Panel
      color={BODY}
      borderTop={`3px solid ${WHITE}`}
      borderBottom={`1px solid ${PB90T}`}>
      <Flex direction="column" alignItems="center">
        <Box px="5px" py="25px" width="100%">
          <HeadingTop level="2">{jt`Get ${startedToday}`}</HeadingTop>
          <Heading level="2">{jt`with a ${free} account`}</Heading>
          <PromoButton
            isFullWidth
            size="large"
            align="center"
            variant="larger-text"
            onClick={() => dispatch(openSigninDialog('createAccount'))}>
            {t`Create a free account`}
          </PromoButton>
        </Box>
      </Flex>
    </Panel>
  )
}

export { CallToAction }
